















































import { Vue, Component } from "vue-property-decorator";
import { State, Action, namespace } from "vuex-class";
const reimbursement = namespace("reimbursement");
import { setStore, getStore } from "@/utils/utils";
import { BillContent, DateFilterCommon } from "@/components";
@Component({
  name: "reimbursement",
  components: {
    BillContent,
    DateFilterCommon,
  },
})
export default class Reimbursement extends Vue {
  @reimbursement.Action getReimbursementList: any;
  searchInfo: any = ""; // 搜索框绑定值
  loading: boolean = false;
  finished: boolean = false;
  reimbursementList: any = {};
  minDate: any = new Date(this.$moment().subtract(1, "years"));
  maxDate: any = new Date(2090, 11, 31);
  pageNum: number = 1;
  pageSize: number = 10;
  loadingPage: any = false; // 页面加载中
  showPicker: any = false;
  active: any = "0";
  dateObj: any = {};
  created() {
    let data: any = this.$route.query.params;
    let params = {
      note: this.searchInfo,
      pageSize: 10,
      pageNum: 1,
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
      retuDayQ: (data && data.dueDateTime) || [],
      retuMonthQ: (data && data.dateMonth) || null,
    };
    this.queryReimbursementList(params);
  }

  onLoad() {
    let data: any = this.$route.query.params;
    this.pageNum++;
    let params = {
      note: this.searchInfo,
      pageSize: 10,
      pageNum: this.pageNum,
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
      retuDayQ: (data && data.dueDateTime) || [],
      retuMonthQ: (data && data.dateMonth) || null,
    };
    this.queryReimbursementList(params);
  }

  searchClick(type) {
    if (type == "filter") {
      // 筛选
      this.showPicker = true;
    } else {
      // 查询
      //   let param = {
      //     custId: JSON.parse(getStore('userInfo')).custId || '',
      //     pageSize: 10000,
      //     pageNum: 1,
      //     note: this.searchInfo,
      //     retuDayQ: (this.dateObj && this.dateObj.dueDateTime) || [],
      //     retuMonthQ: (this.dateObj && this.dateObj.dateMonth) || null
      //   }
      //   this.queryReimbursementList(param)
    }
  }
  // list接口请求
  queryReimbursementList(params) {
    // this.reimbursementList = {}
    this.loadingPage = false;
    this.getReimbursementList(params).then((res) => {
      this.loadingPage = true;
      let obj: any = {};

      if (res["code"] == 200) {
        if (res.data.list == null || res.data.list.length == 0) {
          obj = {};
        } else {
          let data: any = res.data.list;
          for (let i = 0; i < data.length; i++) {
            let M = data[i]["acTime"].slice(0, 7); // 获取年月
            if (obj.hasOwnProperty(M)) {
              obj[M].push(data[i]);
            } else {
              obj[M] = [data[i]];
            }
          }
          this.reimbursementList = obj;
          if (res.data.list.length < this.pageSize) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      }
    });
  }
  onConfirm(value) {
    this.dateObj = value;
    this.showPicker = false;
    if (value.dueDateTime.length) {
      this.searchInfo = value.defaultDate.splice(",").join("-");
    } else if (value.dateMonth) {
      this.$set(this, "searchInfo", value.dateMonth);
    } else {
      this.searchInfo = "";
    }
    let param: any = {
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
      pageSize: 10,
      pageNum: 1,
      note: "",
      retuDayQ: value.dueDateTime,
      retuMonthQ: value.dateMonth || null,
    };
    this.$set(this, "reimbursementList", {});
    // this.reimbursementList = {}
    this.queryReimbursementList(param);
  }
  onCancel() {
    this.showPicker = false;
  }
  //   inputClick(val) {
  //     let timer = 0
  //     let that = this
  //     clearInterval(timer)
  //     timer = setInterval(() => {
  //       let param = {
  //         custId: JSON.parse(getStore('userInfo')).custId || '',
  //         pageSize: 10000,
  //         pageNum: 1,
  //         note: val,
  //         retuDayQ: (this.dateObj && this.dateObj.dueDateTime) || [],
  //         retuMonthQ: (this.dateObj && this.dateObj.dateMonth) || null
  //       }
  //       that.queryReimbursementList(param)
  //     }, 3000)
  //   }
}
